import { RestRequest, RestContext, ResponseFunction } from 'msw'
import {
  addToEntityListData,
  updateEntityListData,
  deleteEntityListData,
} from '../../modules/mockDataCommon'
import { requireAuthenticatedUser } from '../../decorators'
import { getOpportunityContactListData } from './mockData'

const postOpportunityContact = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return addToEntityListData(req, res, ctx, getOpportunityContactListData)
}

const patchOpportunityContact = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return updateEntityListData(req, res, ctx, getOpportunityContactListData)
}

const deleteOpportunityContact = async (
  req: RestRequest,
  res: ResponseFunction,
  ctx: RestContext
) => {
  return deleteEntityListData(req, res, ctx, getOpportunityContactListData)
}

export const handlers = [
  {
    method: 'post',
    path: '/api/opportunitycontacts',
    handler: postOpportunityContact,
  },
  {
    method: 'patch',
    path: '/api/opportunitycontacts/:id',
    handler: patchOpportunityContact,
  },
  {
    method: 'delete',
    path: '/api/opportunitycontacts/:id',
    handler: deleteOpportunityContact,
  },
].map((h) => ({ ...h, ...{ handler: requireAuthenticatedUser(h.handler) } }))
